/**
 * 파일 다운로드 유틸리티
 * Edge 브라우저에서 Office Online으로 리다이렉트되는 문제 해결
 */

/**
 * URL에서 파일을 Blob으로 다운로드
 * - Edge에서 .pptx 파일이 Office Online으로 열리는 것을 방지
 * - 모든 브라우저에서 직접 다운로드 동작 보장
 *
 * @param {string} url - 다운로드할 파일 URL
 * @param {string} filename - 저장할 파일명
 * @returns {Promise<boolean>} - 다운로드 성공 여부
 */
export const downloadFile = async (url, filename) => {
  try {
    // fetch로 파일을 Blob으로 가져오기
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`다운로드 실패: ${response.status}`);
    }

    const blob = await response.blob();

    // Blob URL 생성
    const blobUrl = URL.createObjectURL(blob);

    // 다운로드 링크 생성 및 클릭
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Blob URL 해제 (메모리 정리)
    URL.revokeObjectURL(blobUrl);

    return true;
  } catch (error) {
    console.error('[downloadUtils] 다운로드 오류:', error);

    // Fallback: 기존 방식으로 시도
    try {
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return true;
    } catch (fallbackError) {
      console.error('[downloadUtils] Fallback 다운로드도 실패:', fallbackError);
      return false;
    }
  }
};
